import { render, staticRenderFns } from "./CustomersReminder.vue?vue&type=template&id=17e72bf8&scoped=true"
import script from "./CustomersReminder.vue?vue&type=script&lang=js"
export * from "./CustomersReminder.vue?vue&type=script&lang=js"
import style0 from "./CustomersReminder.vue?vue&type=style&index=0&id=17e72bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e72bf8",
  null
  
)

export default component.exports